<template>
  <div>
    <v-app-bar
      dense
      flat
      height="50"
    >
      <v-row align="center">
        <v-col
          xs="12"
          sm="6"
          md="5"
          class="d-none d-sm-flex"
        >
          <search-field
            :search-key-options="searchKeyOptions"
            :search-key="searchKey"
            :search-text="searchText"
            :status="status"
            @statusChange="changeStatus"
            @search="onSearch"
            @onSearchKeyChange="onSearchKeyChange"
          />
          <version-filter
            pos-version="posVersion"
            @search="onVersionChange"
          />
        </v-col>
        <v-col
          xs="12"
          sm="6"
          md="7"
          align="end"
          class="d-none d-flex justify-end align-center"
        >
          <v-btn
            color="primary"
            class="mr-3 elevation-0"
            @click="ExportPosServerList()"
          >
            <v-icon>mdi-cloud-download</v-icon>
          </v-btn>
          <v-badge
            v-if="newCount" 
            :content="newCount"
            color="primary"
            overlap
            class="mr-3"
          >
            <v-btn
              :color="!showUnapprovedStatus ? 'primary' :undefined "
              :outlined="showUnapprovedStatus"
              :text-color="!showUnapprovedStatus ? 'white' : 'black'"
              class="mr-2"
              @click="toggleClick"
            >
              New
            </v-btn>
          </v-badge>

          <v-btn
            id="menu_item_refresh"
            color="primary"
            :loading="loader"
            class="mr-2 elevation-0"
            @click.native="reload()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-card
      flat
      outlined
      tile
    >
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            class="d-flex d-sm-none"
          >
            <search-field
              :search-key-options="searchKeyOptions"
              :search-key="searchKey"
              :search-text="searchText"
              :status="status"
              @statusChange="changeStatus"
              @search="onSearch"
              @onSearchKeyChange="onSearchKeyChange"
            />
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-divider></v-divider>
        </v-row> -->
        <v-row>
          <v-col
            xs="12"
            class="pa-0"
          >
            <v-data-table
              :headers="headers"
              :items="posServers"
              :items-per-page="limit"
              :loading="loader"
              hide-default-footer
              mobile-breakpoint="0"
            >
              <template v-slot:[`item.name`]="{ item }">
                <div>
                  {{ item.name }}
                  <v-icon
                    v-if="item.cloudServer"
                    small
                    title="Cloud server"
                    color="primary"
                    class="ml-1"
                  >
                    mdi-cloud
                  </v-icon>
                </div>
              </template>

              <template v-slot:[`item.store`]="{ item }">
                <v-chip
                  v-show="item.store"
                  label
                  @click="openAssignedStores(item)"
                >
                  {{ item.store }}
                </v-chip>
                <v-btn
                  color="primary"
                  icon
                  small
                  @click="assignStore(item.id)"
                >
                  <v-icon small>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.activeStatus`]="{ item }">
                <v-chip
                  label
                  :color="!item.approvedStatus ? 'primary' : (item.activeStatus ? 'success' : 'error') "
                >
                  <!-- {{ item.activeStatus ? "Active" : "In-active" }} -->
                  {{ !item.approvedStatus ? "New" : (item.activeStatus ? "Active" : "In-active") }}
                </v-chip>
              </template>
              <template v-slot:[`item.options`]="{ item }">
                <pos-server-options
                  :pos-server="item"
                  @edit="edit"
                  @reload="getPosServers"
                />
              </template>
            </v-data-table>

            <edit-pos-server
              ref="editPosServer"
              @reload="getPosServers"
            />
            <assign-store
              ref="assignStore"
              @reload="getPosServers"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-show="totalPage > 1">
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="totalPage"
              :total-visible="7"
              @input="getPosServers()"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { failure, pagination } from "@/mixins/common";
import SearchField from "@/components/utils/SearchField";
import VersionFilter from "./VersionFilter";
import PosServerOptions from "./PosServerOptions";
import EditPosServer from "./EditPosServer";
import AssignStore from "./AssignStore";
import exportReport from "@/mixins/report";

export default {
  components: {
    SearchField,
    VersionFilter,
    PosServerOptions,
    EditPosServer,
    AssignStore
  },
  mixins: [failure, pagination, exportReport],
  data() {
    return {
      loader: false,
      headers: [
        { text: "Name", value: "name", sortable: false },
        { text: "Device name", value: "reference", align: "center", sortable: false },
        { text: "PosId", value: "posId", align: "center" , sortable: false},
        { text: "Pos Version", value: "posVersion", align: "center", sortable: false },
        { text: "Stores", value: "store", align: "center", sortable: false },
        { text: "Status", value: "activeStatus", align: "center", sortable: false },
        { text: "", value: "options", align: "end", sortable: false }
      ],
      searchKeyOptions: [
        {id: "name", name: "Name"},
        {id: "pos_id", name: "PosId"},
        {id: "reference", name: "Device"}
      ],
      posServers: [],
      searchKey: "name",
      sortKey: "name",
      searchText: null,
      posVersion:"",
      page: 1,
      totalPage: 0,
      status: "1",
      selectedId: null,
      showUnapprovedStatus:true,
      newCount:0
    };
  },
  created() {
    this.init();
  },
  methods: {
    toggleClick() {
      this.showUnapprovedStatus = !this.showUnapprovedStatus;
      this.getPosServers();
    },
    getPosServers() {
      this.loader = true;
      let newstatus = "1";
      if(!this.showUnapprovedStatus){
        newstatus = "2";
      }
      let url = `${this.ADMIN_API_URL}/posServers?page=${
        this.page - 1
      }&search_key=${this.searchKey}&sort_key=${this.sortKey}&limit=${this.limit}&status=${this.status}&approvedstatus=${newstatus}`;
      if (this.searchText) {
        url += `&search=${this.searchText}`;
      }
      if (this.posVersion) {
        url += `&pos_version=${this.posVersion}`;
      }
      this.$http.get(url).then(
        (res) => {
          this.posServers = res.body.data || [];
          this.newCount = res.body.unApprovedCount;
          this.totalPage = res.body.totalPage;
          this.page = res.body.pagination.page + 1;
          this.loader = false;
        },
        (failure) => {
          this.handleFailure(failure);
        }
      );
    },
    search() {
      this.page = 1;
      this.getPosServers();
    },
    reload() {
      this.searchText = null;
      this.status = "";
      this.showUnapprovedStatus = true, //for refresh new
      this.search();
    },
    onVersionChange(val) {
      this.posVersion = val;
      if (!val || val.length >= 4) {
        this.search();
      }
    },
    onSearch(val) {
      this.searchText = val;
      if (!val || val.length >= 3) {
        this.search();
      }
    },
    onSearchKeyChange(val) {
      this.searchKey = val;
      this.reload();
    },
    changeStatus(status) {
      this.status = status;
      this.search();
    },
    init() {
      this.$store.commit("setTitle", "Pos Servers");
      this.getPosServers();
    },
    edit(id,status) {
      this.$refs.editPosServer.open(id,status);
    },
    assignStore(id) {
      this.$refs.assignStore.open(id);
    },
    openAssignedStores(server) {
      this.$refs.assignStore.openAssignedStores(server.id, server.stores);
    },
    ExportPosServerList() {
      let url = `${this.ADMIN_API_URL}/export/posServers`;
      this.exportReport(url, ".csv", "Pos_server_list");
    }
  }
  
};
</script>